import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class SuccessModalStore extends BaseModalStore {
  @observable qrcodeImg = '';
  @observable loading = false;
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /** 关闭弹窗 */
  onSuccessModalClose = () => {
    this.onClickClose();
    if (this.closeCb) this.closeCb();
    this.onClose();
  };

  getQrcode = async () => {
    this.loading = true;
    try {
      const res = await this.$ztService.getQrCode();
      this.qrcodeImg = res?.img || '';
    } catch (error) {
      this.qrcodeImg = '';
    } finally {
      this.loading = false;
    }
  };

  use(onClose) {
    super.use();
    if (onClose) {
      this.onClose = onClose;
    }
    useMount(() => this.getQrcode());
  }
}

export default SuccessModalStore;
